export const OPEN_WARNING_DIALOG = 'OPEN_WARNING_DIALOG'
export const CLOSE_WARNING_DIALOG = 'CLOSE_WARNING_DIALOG'

export const openWarningDialog = (data) => ({
  type: OPEN_WARNING_DIALOG,
  payload: data,
})

export const closeWarningDialog = () => ({
  type: CLOSE_WARNING_DIALOG,
})
